import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { FeedbackLight } from './views/FeedbackLight';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<FeedbackLight />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.FeedbackLight)
	.build();

export default Layout;
